var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinentEuropeCountrygermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1900_45941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9999C0 18.7072 0.280952 19.3854 0.781049 19.8855C1.28115 20.3856 1.95942 20.6666 2.66667 20.6666H21.3333C22.0406 20.6666 22.7189 20.3856 23.219 19.8855C23.719 19.3854 24 18.7072 24 17.9999V15.3333H0V17.9999Z",
    fill: "#FFCD05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.33325H24V15.3333H0V9.33325Z",
    fill: "#ED1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 3.33325H2.66667C1.95942 3.33325 1.28115 3.6142 0.781049 4.1143C0.280952 4.6144 0 5.29267 0 5.99992L0 9.33325H24V5.99992C24 5.29267 23.719 4.6144 23.219 4.1143C22.7189 3.6142 22.0406 3.33325 21.3333 3.33325Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1900_45941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinentEuropeCountrygermany);
export default __webpack_public_path__ + "static/media/Continent=Europe, Country=germany.25e0181cb6c74c059496fa8878c22084.svg";
export { ForwardRef as ReactComponent };